<template>
  <div class="page-header clear-filter" filter-color="orange">
    <div class="page-header-image" style="background-image: url('img/login.jpg')"></div>
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto">
          <card type="login" plain>
            <div slot="header" class="logo-container">
              <img v-lazy="'img/now-logo.png'" alt />
            </div>
            <div class="notice-box">
                {{this.notice}}
            </div>
            <TextInput :rules="'required'" placeholder="Company Email"
              v-model="form.company" />
            <fg-input
              type="email"
              class="no-border input-lg"
              placeholder="Company Email"
              v-model="form.company"
            ></fg-input>
            <p v-if="errors" class="error-block bg-red">{{errors}}</p>
            <template slot="raw-content">
              <div @click="sendEmail" class="card-footer text-center">
                <div class="btn btn-primary btn-round btn-lg btn-block">
                  <img v-if="isLoggingIn" class="btn-loader" src="/img/small_loader.svg" alt />
                  <span v-else>Login</span>
                </div>
              </div>
              <div class="pull-left">
                <h6>
                  <a href="#pablo" class="link footer-link">Create Account</a>
                </h6>
              </div>
              <div class="pull-right">
                <h6>
                  <a href="#pablo" class="link footer-link">Need Help?</a>
                </h6>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
    <!-- <main-footer></main-footer> -->
  </div>
</template>
<script>
import { Card, Button } from "@/components";
import TextInput from "./components/Inputs/TextInput"
import {auth} from "../Firebase/firebase"
//import MainFooter from '@/layout/MainFooter';
export default {
  name: "login-page",
  bodyClass: "login-page",
  components: {
    Card,
    //MainFooter,
    [Button.name]: Button,
    TextInput
  },
  data() {
    return {
      form: {
        company: "",
        notice:"",
      }
    };
  },
  methods: {
    Login() {
      this.$store.dispatch("Auth/login", this.form).then(() => {
        this.$router.push("/dashboard");
      });
    },
    sendEmail() {
      auth
        .sendPasswordResetEmail(this.form.company)
        .then(()=> {
          this.notice="A password recovery link has been sent to your email"
        })
        .catch((error)=> {
          /* console.log(error) */
        });
    }
  },
  computed: {
    isLoggingIn() {
      return this.$store.state.Auth.isLoggingIn;
    },
    errors() {
      return this.$store.state.Auth.errors;
    }
  }
};
</script>
<style>
.btn-loader {
  width: auto;
  height: 20px;
}

.error-block {
  background: #f03d3d;
  font-size: 12px;
  font-weight: 500;
  border-radius: 50px;
  margin-top: 20px;
}
</style>
